import { FunctionComponent } from 'react';
import getConfig from 'next/config';
import { GoogleLogin } from '@react-oauth/google';
import jwt from 'jsonwebtoken';

import ApiGoogleUserDetails from 'types/api/GoogleUserDetails';

import GoogleUserDetails from 'models/GoogleUserDetails';

import { Props } from './index';
import StyledComponent from './styles';


const LayoutButtonGoogle: FunctionComponent<Props> = ({ headline, onSuccess, onError }) => {
    const { publicRuntimeConfig } = getConfig();
    const readyToWork = Boolean(publicRuntimeConfig.GOOGLE_CLIENT_ID);

    return (
        <StyledComponent className="layout-button-google">
            {readyToWork && (
                <>
                    {headline && <p className='layout-button-google-title'>{headline}</p>}
                    <GoogleLogin
                        theme='outline'
                        size='large'
                        type='standard'
                        width='500'
                        text='continue_with'
                        onSuccess={credentialResponse => {
                            const decodedCredential: ApiGoogleUserDetails = jwt.decode(credentialResponse?.credential);
                            const parsedCredential = new GoogleUserDetails(decodedCredential);

                            onSuccess(credentialResponse?.credential, parsedCredential);
                        }}
                        onError={() => onError()}
                    />
                </>
            )}
        </StyledComponent>
    );};

export default LayoutButtonGoogle;
